// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Hide: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 48"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M3.6 24.1c4.7-7.4 13-11.9 21.9-11.9 1.9 0 3.7.2 5.5.6l2.3-2.3c-2.5-.7-5.1-1.1-7.8-1.1-10.1 0-19.6 5.3-24.7 14l-.4.7.4.7c2.2 3.8 5.3 6.9 8.9 9.3l2-2c-3.2-2.1-6-4.8-8.1-8zm46.6-.7c-2.8-4.7-6.8-8.4-11.6-10.8l10-10L46.7.7 2 45.4l1.9 1.9 10.7-10.7c3.4 1.4 7.1 2.2 10.9 2.2 10.1 0 19.6-5.3 24.7-14l.4-.7-.4-.7zm-17.9.7c0 3.7-3 6.6-6.8 6.6-1.4 0-2.7-.4-3.8-1.2l9.3-9.3c.8 1.1 1.3 2.4 1.3 3.9zM25.5 36c-3 0-6-.5-8.8-1.5l3-3c1.6 1.2 3.6 2 5.8 2 5.3 0 9.5-4.2 9.5-9.4 0-2.2-.8-4.2-2.1-5.8l3.6-3.6c4.4 2 8.2 5.3 10.8 9.4C42.7 31.4 34.4 36 25.5 36z"/></svg>;
};

export default React.memo(Hide);
